import { Navigate, Route, Routes } from "react-router-dom";
import { ClosetPage } from "../pages/Closet";
import { Syncing } from "@/pages/Onboarding";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Main app */}
      <Route path="/closet" element={<ClosetPage />} />
      <Route path="/syncing" element={<Syncing />} />

      <Route path="*" element={<Navigate to="/closet" replace />} />
    </Routes>
  );
};

export default AppRoutes;
